import React from "react";
import styled from "styled-components";
import type { RaangeDataTableSortDirection } from "./RaangeDataTableSort";

export interface IRaangeDataTableDirectionFormatterProps {
  children?: RaangeDataTableSortDirection;
}

export const RaangeDataTableDirectionFormatter = ({
  children,
}: IRaangeDataTableDirectionFormatterProps) => {
  if (!children) {
    return null;
  }

  if (children === "asc") {
    return <SortDirectionStyled className="fas fa-sort-up" />;
  } else if (children === "desc") {
    return <SortDirectionStyled className="fas fa-sort-down" />;
  } else {
    return null;
  }
};

const SortDirectionStyled = styled.i`
  margin-left: 0.5rem;

  &.fa-sort-up {
    transform: translateY(5px);
  }

  &.fa-sort-down {
    transform: translateY(-2px);
  }
`;
